<!-- mettal-3\src\components\View612.vue -->
<template>
  <div :class="[`view-115`, className || ``]">
    <div class="rectangle-82"></div>
    <div class="x1-6 poppins-semi-bold-white-8px">2</div>
  </div>
</template>

<script>
export default {
  name: "View612",
  props: ["className"],
};
</script>

<style>
.view-115 {
  height: 16px;
  left: 25px;
  position: absolute;
  top: 0;
  width: 18px;
}

.rectangle-82 {
  aspect-ratio: 1;
  background-color: var(--suva-gray);
  border: 2px solid;
  border-color: var(--white);
  border-radius: 60px;
  height: 16px;
  left: 0;
  position: absolute;
  top: 0;
  width: 16px;
}

.x1-6 {
  left: 6px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 2px;
  white-space: nowrap;
  width: 5px;
}

.view-115.view-126 {
  left: 0;
}
</style>
